// @ts-nocheck
import { statusOptions } from 'utils/constants';

const CANCELLED_STATUS = 'cancelled';
const DANISH_PHONE_REGEX = /^\d{8}$/;
const DANISH_PHONE_WITH_COUNTRY_CODE_REGEX = /^\+45\d{8}$/;
const STANDARD_NAME_PART_REGEX = /^[A-ZÆØÅ][a-zæøå]+(?:[-'][A-ZÆØÅ]?[a-zæøå]+)*$/;

const normalizeWhitespace = (value = '') => String(value).replace(/\s+/g, ' ').trim();

const getCustomerName = (customer = {}) => {
    const nestedName = customer?.name;
    if (typeof nestedName === 'string' && nestedName.trim()) return normalizeWhitespace(nestedName);

    const firstName = customer?.firstName || nestedName?.firstName || customer?.givenName || customer?.contact?.firstName;
    const lastName = customer?.lastName || nestedName?.lastName || customer?.familyName || customer?.contact?.lastName;
    const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

    return normalizeWhitespace(fullName || customer?.fullName || nestedName?.fullName || '');
};

const getCustomerPhone = (customer = {}) => (
    customer?.phone
    || customer?.phoneNumber
    || customer?.mobile
    || customer?.mobilePhone
    || customer?.contact?.phone
    || customer?.contact?.phoneNumber
    || ''
);

const isDanishPhoneNumber = (phoneNumber = '') => {
    const normalizedPhoneNumber = String(phoneNumber).replace(/\s+/g, '');
    return DANISH_PHONE_REGEX.test(normalizedPhoneNumber) || DANISH_PHONE_WITH_COUNTRY_CODE_REGEX.test(normalizedPhoneNumber);
};

const isStandardCustomerName = (name = '') => {
    const normalizedName = normalizeWhitespace(name);
    if (!normalizedName) return false;

    const parts = normalizedName.split(' ');
    return parts.length >= 2 && parts.every((part) => STANDARD_NAME_PART_REGEX.test(part));
};

const isSpamOrder = (order = {}) => {
    const customer = order?.customer || {};
    const customerName = getCustomerName(customer);
    const customerPhone = getCustomerPhone(customer);

    if (!customerName || !customerPhone) {
        return false;
    }

    return !isDanishPhoneNumber(customerPhone) && !isStandardCustomerName(customerName);
};

export const getVisibleStatusOptions = (showCancelled = false) => (
    showCancelled
        ? statusOptions
        : statusOptions.filter((status) => status.value !== CANCELLED_STATUS)
);

export const sanitizeStatusFilters = (filters = [], showCancelled = false) => (
    showCancelled
        ? filters
        : filters.filter((filter) => !(filter?.property === 'status' && filter?.value === CANCELLED_STATUS))
);

export const filterVisibleOrders = (orders = [], filters = [], showCancelled = false, showSpamOnly = false) => {
    const visibleOrdersBySpamSetting = showSpamOnly
        ? orders.filter((order) => isSpamOrder(order))
        : orders.filter((order) => !isSpamOrder(order));

    if (showCancelled) {
        return visibleOrdersBySpamSetting;
    }

    // Default hiding happens client-side because the current access/orders stack rejects
    // the grouped OR-filter shape that would otherwise be needed for a frontend-only request.

    const selectedStatus = filters.find((filter) => filter?.property === 'status')?.value;

    if (selectedStatus) {
        return visibleOrdersBySpamSetting;
    }

    return visibleOrdersBySpamSetting.filter((order) => order?.status !== CANCELLED_STATUS);
};
